
import Vue, { PropType } from "vue";
import axios from "axios";
import { KeyValuePairOfIntegerAndString }  from '../../../types/Sapphire_dto';
import Multiselect from "vue-multiselect";

export default Vue.extend({
    name: "patient-search",
    components: {
        Multiselect,
    },
    props: {
        patient:  Object as PropType<KeyValuePairOfIntegerAndString>,
    },
    data: function () {
        return {
            isLoading: false,                    
            chkPatInactive: false,
            chkPatReleased: false,
            chkPatTransferred: false,
            patientOptions: [] as KeyValuePairOfIntegerAndString[],
            selectedPatient: null as KeyValuePairOfIntegerAndString,
        };
    },
    mounted: function () {
    },
    watch: {
        chkPatInactive: function(newVal, oldVal) {
            if (newVal != oldVal) {
                this.selectedPatient = null;
                this.patientOptions.splice(0);
            }
        },
        chkPatTransferred: function(newVal, oldVal) {
            if (newVal != oldVal) {
                this.selectedPatient = null;
                this.patientOptions.splice(0);
            }
        },
        chkPatReleased: function(newVal, oldVal) {
            if (newVal != oldVal) {
                this.selectedPatient = null;
                this.patientOptions.splice(0);
            }
        },
        patient: function(newVal, oldVal) {
            if (newVal != oldVal) {
                this.selectedPatient = newVal;
                //console.log("in patient watch");
                //this.patientSelected();
            }
        },
        selectedPatient: function(newVal, oldVal) {
            if (newVal != oldVal) {
                //console.log("in patient watch");
                this.$emit('PatientSearchPatientSelected', this.selectedPatient);
            }
        },
    },
    methods: {
        async getPatients(query) {
            if( query.length >= 3 ) {
                this.isLoading = true
                var context = '';

                if (this.chkPatInactive)
                    context = 'INACTIVE';

                if (this.chkPatTransferred)
                    context += 'TRANSFERRED';

                if (this.chkPatReleased)
                    context += 'RELEASED';

                const response = await axios.post("../../Common/Services/EMARClientOperations.svc/GetPatientsVue",
                {
                    prefixText: query,
                    contextKey: context,

                });
                this.patientOptions.splice(0);
                this.patientOptions = JSON.parse(response.data.d);
                this.isLoading = false;
            }
        },
        patientSelected() {
            console.log("in patientSelected on patient search");
            this.$emit('patient-selected', this.selectedPatient);
        }
    }
});

